import { ANON_BIS_BUCKET, MODAL_TYPE } from "../../../constants";
import { BUTTON_TYPES } from "../../buttons/button/ButtonTypes";

export type VariantConfig = {
  mobileModalType: string;
  headingKey: string;
  bodyKeys: string[];
  onEmailRegistered: "showGuard" | "redirect";
  showSignInFirst: boolean;
  notifyButtonType: string;
  twoStep: boolean;
};

export const VARIANT_CONFIGS: Record<string, VariantConfig> = {
  [ANON_BIS_BUCKET.V1]: {
    mobileModalType: MODAL_TYPE.BOTTOM,
    headingKey: "back_in_stock_sign_in_modal_heading",
    bodyKeys: ["anonymous_back_in_stock_modal_body"],
    onEmailRegistered: "showGuard",
    showSignInFirst: false,
    notifyButtonType: BUTTON_TYPES.primary,
    twoStep: false,
  },
  [ANON_BIS_BUCKET.V2]: {
    mobileModalType: MODAL_TYPE.FULL_PAGE,
    headingKey: "back_in_stock_sign_in_modal_heading",
    bodyKeys: ["anonymous_back_in_stock_modal_body"],
    onEmailRegistered: "showGuard",
    showSignInFirst: false,
    notifyButtonType: BUTTON_TYPES.primary,
    twoStep: false,
  },
  [ANON_BIS_BUCKET.V3]: {
    mobileModalType: MODAL_TYPE.FULL_PAGE,
    headingKey: "back_in_stock_sign_in_modal_heading",
    bodyKeys: ["anonymous_back_in_stock_modal_body"],
    onEmailRegistered: "redirect",
    showSignInFirst: false,
    notifyButtonType: BUTTON_TYPES.primary,
    twoStep: false,
  },
  [ANON_BIS_BUCKET.V4]: {
    mobileModalType: MODAL_TYPE.FULL_PAGE,
    headingKey: "back_in_stock_sign_in_modal_heading",
    bodyKeys: [
      "back_in_stock_sign_in_modal_title",
      "back_in_stock_sign_in_modal_text",
    ],
    onEmailRegistered: "redirect",
    showSignInFirst: true,
    notifyButtonType: BUTTON_TYPES.secondary,
    twoStep: false,
  },
  [ANON_BIS_BUCKET.V5]: {
    mobileModalType: MODAL_TYPE.FULL_PAGE,
    headingKey: "back_in_stock_sign_in_modal_heading",
    bodyKeys: [
      "back_in_stock_sign_in_modal_title",
      "back_in_stock_sign_in_modal_text",
    ],
    onEmailRegistered: "redirect",
    showSignInFirst: true,
    notifyButtonType: BUTTON_TYPES.secondary,
    twoStep: true,
  },
};

export const DEFAULT_VARIANT_CONFIG: VariantConfig =
  VARIANT_CONFIGS[ANON_BIS_BUCKET.V1];
